/*
 * Ariser: sticky desktop dropdown menus.
 *
 * Stock Minimog behaviour: dropdowns and level-2 flyouts open on hover and
 * close the instant the pointer leaves them, so a slight mouse slip closes
 * the whole menu. This script keeps a menu open (via an `is-open` class,
 * styled in custom.css.liquid) until the visitor:
 *   - hovers a different top-level menu item,
 *   - clicks anywhere outside the navigation,
 *   - presses Escape, or
 *   - scrolls the page.
 * Links still navigate exactly as before. Mobile drawer menu is untouched.
 */
(function () {
  'use strict';

  var OPEN = 'is-open';
  var navs = document.querySelectorAll('.sf-menu-wrapper__desktop .sf-nav');
  if (!navs.length) return;

  function isVisible(el) {
    return !!el && el.offsetParent !== null;
  }

  function closeWithin(root, except) {
    root.querySelectorAll('.' + OPEN).forEach(function (el) {
      if (el === except || (except && except.contains(el))) return;
      el.classList.remove(OPEN);
    });
  }

  function closeAll() {
    navs.forEach(function (nav) { closeWithin(nav); });
  }

  navs.forEach(function (nav) {
    // Level 1: top-level items that have a dropdown.
    nav.querySelectorAll(':scope > .sf-menu-item').forEach(function (item) {
      if (!item.querySelector('.sf-menu__submenu')) return;
      item.addEventListener('mouseenter', function () {
        if (!isVisible(nav)) return;
        closeWithin(nav, item);
        item.classList.add(OPEN);
      });
    });

    // Level 2: items that have their own flyout.
    nav.querySelectorAll('.sf__menu-item-level2').forEach(function (item) {
      if (!item.querySelector('.sf-menu--sub-childlink')) return;
      item.addEventListener('mouseenter', function () {
        if (!isVisible(nav)) return;
        var list = item.parentElement;
        if (list) {
          list.querySelectorAll(':scope > .sf__menu-item-level2.' + OPEN).forEach(function (sib) {
            if (sib !== item) sib.classList.remove(OPEN);
          });
        }
        item.classList.add(OPEN);
      });
    });
  });

  document.addEventListener('click', function (evt) {
    var inside = false;
    navs.forEach(function (nav) { if (nav.contains(evt.target)) inside = true; });
    if (!inside) closeAll();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc') closeAll();
  });

  window.addEventListener('scroll', closeAll, { passive: true });
})();
